import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const upcomingEvents = [
  {
    id: 1,
    title: 'He Said, She Said Part 2',
    date: 'February 7, 2026',
    time: '12:00 PM - 3:00 PM',
    location: '4700 Camp Grandview Road, 36054 (Club House)',
    category: 'Education',
    description:
      'Join author and host LaTonya Duncan for Part 2 of the conversation! Featuring guest speaker RoiLisa Derico, LMT & CFM Certified Instructor Lu Rawls, and performance by Keith Beard. New book release: Pillow Talk - From Surface Talk to Soul Talk. Introducing new massage oil "BARE". Includes DJ, food vendors, door prizes, couples panel, and small fashion show. RSVP: 334-777-7751',
    image:
      'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/a26e4dfe477739b987a7e5128805c389.jpeg',
    spots: 'Limited capacity',
    registration: 'Open',
  },
  {
    id: 2,
    title: 'Heart Health Screening & Education Fair',
    date: 'May 21, 2026',
    time: '10:00 AM - 3:00 PM',
    location: 'Community Center, 123 Main Street',
    category: 'Health Screening',
    description:
      'Free blood pressure checks, cholesterol screenings, and cardiovascular wellness education. Learn about heart-healthy nutrition and exercise.',
    image:
      'https://public.readdy.ai/ai/img_res/bec7c27b98e4632902dfd237662a47ff.jpg',
    spots: '50 spots available',
    registration: 'Open',
  },
  {
    id: 3,
    title: 'Mental Health Awareness Workshop',
    date: 'March 22, 2025',
    time: '6:00 PM - 8:00 PM',
    location: 'Hope Psychiatric Consultants',
    category: 'Education',
    description:
      'Join us for an evening of mental wellness education, stress management techniques, and community support. Breaking stigma together.',
    image:
      'https://readdy.ai/api/search-image?query=african%20american%20counselor%20leading%20mental%20health%20awareness%20workshop%20with%20diverse%20african%20american%20participants%20sitting%20in%20supportive%20circle%20discussion%20group%20in%20calming%20room%20with%20plants%20soft%20lighting%20teal%20and%20purple%20mental%20wellness%20posters%20creating%20safe%20comfortable%20educational%20healing%20environment&width=800&height=600&seq=event002aa&orientation=landscape',
    spots: '30 spots available',
    registration: 'Open',
  },
  {
    id: 4,
    title: 'Fashion Show for a Cause',
    date: 'April 5, 2025',
    time: '7:00 PM - 10:00 PM',
    location: 'Grand Ballroom, Downtown',
    category: 'Fundraiser',
    description:
      'An elegant evening of fashion, entertainment, and fundraising to support our health education programs. Featuring local designers and models.',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20fashion%20show%20runway%20with%20beautiful%20african%20american%20models%20wearing%20stunning%20designer%20outfits%20walking%20down%20catwalk%20african%20american%20audience%20seated%20in%20grand%20ballroom%20with%20dramatic%20stage%20lighting%20health%20awareness%20messages%20on%20screens%20creating%20sophisticated%20fundraising%20gala%20atmosphere&width=800&height=600&seq=event003aa&orientation=landscape',
    spots: 'Limited tickets',
    registration: 'Open',
  },
  {
    id: 5,
    title: 'Breast Cancer Awareness & Screening',
    date: 'April 12, 2025',
    time: '9:00 AM - 2:00 PM',
    location: 'Mobile Mammography Unit',
    category: 'Health Screening',
    description:
      'Free mammogram screenings for eligible women, self-examination education, and survivor support resources. Early detection saves lives.',
    image:
      'https://readdy.ai/api/search-image?query=african%20american%20female%20medical%20professionals%20in%20pink%20shirts%20helping%20african%20american%20women%20at%20breast%20cancer%20screening%20event%20mobile%20mammography%20unit%20volunteers%20distributing%20pink%20ribbons%20and%20educational%20materials%20creating%20supportive%20empowering%20welcoming%20environment%20with%20hope%20messages&width=800&height=600&seq=event004aa&orientation=landscape',
    spots: '40 appointments',
    registration: 'Open',
  },
  {
    id: 6,
    title: 'Diabetes Prevention Workshop',
    date: 'April 19, 2025',
    time: '11:00 AM - 1:00 PM',
    location: 'Community Center',
    category: 'Education',
    description:
      'Learn about diabetes prevention, blood sugar management, healthy eating, and lifestyle modifications. Free glucose screenings available.',
    image:
      'https://readdy.ai/api/search-image?query=african%20american%20healthcare%20professional%20teaching%20diabetes%20education%20workshop%20to%20engaged%20african%20american%20community%20members%20about%20blood%20sugar%20management%20healthy%20meal%20planning%20displays%20glucose%20monitoring%20equipment%20and%20educational%20charts%20in%20bright%20community%20room%20with%20attendees%20taking%20notes&width=800&height=600&seq=event005aa&orientation=landscape',
    spots: '35 spots available',
    registration: 'Open',
  },
  {
    id: 7,
    title: 'Domestic Violence Support Group',
    date: 'April 26, 2025',
    time: '6:30 PM - 8:00 PM',
    location: 'Confidential Location (provided upon registration)',
    category: 'Support Group',
    description:
      'Safe space for survivors to share experiences, receive support, and access resources. Facilitated by trained counselors.',
    image:
      'https://readdy.ai/api/search-image?query=supportive%20safe%20space%20meeting%20room%20with%20comfortable%20seating%20arranged%20in%20circle%20african%20american%20counselor%20facilitating%20support%20group%20soft%20lighting%20calming%20teal%20colors%20tissues%20and%20resources%20available%20creating%20confidential%20healing%20environment%20with%20empowering%20hope%20messages&width=800&height=600&seq=event006aa&orientation=landscape',
    spots: 'Limited capacity',
    registration: 'Confidential',
  },
];

const pastEvents = [
  {
    id: 1,
    title: 'One Voice, One Fight - End Stigma Panel',
    date: 'February 10, 2025',
    attendees: '85+',
    image:
      'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/52dd75a818c0ae044cf650c47815c87e.jpeg',
  },
  {
    id: 2,
    title: 'The Connect Gala',
    date: 'January 20, 2025',
    attendees: '150+',
    image:
      'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/1022bafea314062ab36ccc0896688ed9.jpeg',
  },
  {
    id: 3,
    title: 'Community Wellness Fair',
    date: 'December 15, 2024',
    attendees: '200+',
    image:
      'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/3124fc77bd95185372b821a3459dc36e.jpeg',
  },
  {
    id: 4,
    title: 'Comprehensive Wellness Workshop',
    date: 'November 8, 2024',
    attendees: '60+',
    image:
      'https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/d37b3d25d5340ba8e3c8937988b89e9d.jpeg',
  },
];

const categories = [
  'All Events',
  'Health Screening',
  'Education',
  'Fundraiser',
  'Support Group',
];

export default function EventsPage() {
  const [selectedCategory, setSelectedCategory] = useState('All Events');

  const filteredEvents =
    selectedCategory === 'All Events'
      ? upcomingEvents
      : upcomingEvents.filter((e) => e.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-cream">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20african%20american%20community%20gathering%20at%20health%20education%20event%20with%20volunteers%20helping%20people%20colorful%20event%20banners%20and%20booths%20african%20american%20medical%20professionals%20providing%20screenings%20families%20participating%20in%20wellness%20activities%20showing%20community%20engagement%20hope%20and%20positive%20impact%20with%20warm%20welcoming%20atmosphere&width=1920&height=600&seq=eventhero001aa&orientation=landscape"
            alt="Community Events"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-block bg-coral/90 text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              Join Us
            </span>
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Upcoming Events
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Connect with your community through health screenings, educational
              workshops, and support groups. Together, we create lasting change.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === category
                    ? 'bg-coral text-white shadow-lg'
                    : 'bg-gray-100 text-charcoal hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <h2 className="font-serif text-4xl font-bold text-charcoal mb-3">
              Upcoming Events
            </h2>
            <p className="text-gray-600 text-base">
              Register now to secure your spot at our upcoming community events
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredEvents.map((event, index) => (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all group"
              >
                {/* Image */}
                <div className="relative overflow-hidden h-64">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-coral text-white px-4 py-2 rounded-full text-sm font-semibold">
                    {event.category}
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="font-serif text-xl font-bold text-charcoal mb-3 group-hover:text-coral transition-colors">
                    {event.title}
                  </h3>

                  {/* Date & Time */}
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center space-x-2 text-gray-600 text-sm">
                      <i className="ri-calendar-line text-coral"></i>
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-gray-600 text-sm">
                      <i className="ri-time-line text-coral"></i>
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-gray-600 text-sm">
                      <i className="ri-map-pin-line text-coral"></i>
                      <span>{event.location}</span>
                    </div>
                  </div>

                  <p className="text-gray-700 text-sm leading-relaxed mb-4">
                    {event.description}
                  </p>

                  {/* Spots & Registration */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center space-x-2">
                      <i className="ri-user-line text-coral"></i>
                      <span className="text-sm text-gray-600">{event.spots}</span>
                    </div>
                    <a
                      href="/get-involved"
                      className="bg-coral text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-coral/90 transition-all whitespace-nowrap"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Past Events */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12 text-center"
          >
            <h2 className="font-serif text-4xl font-bold text-charcoal mb-3">
              Past Events
            </h2>
            <p className="text-gray-600 text-base">
              Celebrating our recent community impact
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {pastEvents.map((event, index) => (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group cursor-pointer"
              >
                <div className="bg-cream rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                  <div className="relative overflow-hidden h-56">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="font-serif text-base font-bold text-charcoal mb-2">
                      {event.title}
                    </h3>
                    <div className="flex items-center justify-between text-sm text-gray-600">
                      <span>{event.date}</span>
                      <span className="text-coral font-semibold">
                        {event.attendees} attended
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="/gallery"
              className="inline-block bg-charcoal text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-charcoal/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              View Full Gallery
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-coral to-pink">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6">
              Stay Connected
            </h2>
            <p className="text-xl text-white/95 mb-8 leading-relaxed">
              Never miss an event! Subscribe to our newsletter for updates on
              upcoming programs, health tips, and community news.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/get-involved"
                className="bg-white text-coral px-8 py-4 rounded-full text-base font-semibold hover:bg-white/95 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                Get Involved
              </a>
              <a
                href="/programs"
                className="bg-charcoal text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-charcoal/90 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                View Programs
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
